var MessageCollection = function () { return import('~/pages/smart-collection/message-collection.vue'); };
var MailCollection = function () { return import('~/pages/smart-collection/mail-collection.vue'); };
var LetterCollection = function () { return import('~/pages/smart-collection/letter-collection.vue'); };
export default [
    {
        // 短信催收
        path: '/smart-collection/message-collection',
        name: 'message-collection',
        component: MessageCollection,
    },
    {
        // 邮件催收
        path: '/smart-collection/mail-collection',
        name: 'mail-collection',
        component: MailCollection,
    },
    {
        // 信函打印
        path: '/smart-collection/letter-collection',
        name: 'letter-collection',
        component: LetterCollection,
    }
];
